import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogoMark } from "@/components/Shell";
import { authErrorText, authRedirect, supabase } from "@/lib/supabase";

export default function ForgotPassword() {
  const [email, setEmail] = useState(useLocation().state?.email || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: authRedirect("/auth/reset") });
    setBusy(false);
    if (err) setError(authErrorText(err)); else setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-background" data-testid="forgot-password">
      <div className="max-w-md w-full space-y-6">
        <Link to="/" className="flex items-center gap-3"><LogoMark /><span className="font-display text-lg">LegacyStack AI</span></Link>
        <h1 className="font-display text-3xl sm:text-4xl">Reset your password.</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground" data-testid="forgot-sent">If an account exists for <span className="text-foreground">{email}</span>, a reset link is on its way. It expires in an hour.</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <p className="text-sm text-muted-foreground">Enter your account email and we'll send you a link to choose a new password.</p>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="email" data-testid="forgot-email" className="w-full h-12 rounded-xl border border-border bg-background px-4 text-sm focus:outline-none focus:ring-2 focus:ring-gold/60" />
            {error && <p className="text-sm text-destructive" role="alert">{error}</p>}
            <button type="submit" disabled={busy} className="btn-gold w-full h-12" data-testid="forgot-submit">{busy ? "One moment…" : "Send reset link"}</button>
          </form>
        )}
        <Link to="/auth" className="text-sm text-muted-foreground hover:text-foreground">Back to sign in</Link>
      </div>
    </div>
  );
}
